















import Vue from "vue";
import Component from "vue-class-component";
import Emit from "vue-property-decorator";
import { StringHelpers } from "../../api/helpers/StringHelpers";
import { status } from "../../api/status/status";
import { workorder } from "../../api/workorder/workorder";
@Component({
  name: "AlarmDetails",
  props: {
    details: {
      name: "",
      issuedate: "",
      type: "",
      id: "",
      aia: "",
      comments: ""
    }
  },
  model: {
    prop: "details",
    event: "change"
  }
})
export default class AlarmDetails extends Vue {
  public types: any[] = [];
  public row: any;
  public async fillboxes() {}
  public mounted() {
    this.row = this.$store.getters.getCurrentId;
    this.fillboxes();
    this.$emit("on-loaded");
  }
}
